import React, { CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import Banner from 'components/Banner/Banner';
import { getUser } from 'redux/authentication/auth.slice';
import { useAppSelector } from 'redux/hooks';
import RenderWithRole from 'hoc/renderWithRole';
import UpcomingProvider from 'application/dashboard/upcomings/upcoming.context';
import LatestActivityProvider from 'application/dashboard/latestActivity/latestActivity.context';
import PersistantOptionsProvider from 'application/dashboard/persistantOptions/options.context';

import Upcoming from './components/Upcoming/Upcoming';
import Classes from './components/Classes/Classes';
// import Grades from './components/Grades/Grades';
import LatestChat from './components/LatestChat/LatestChat';
import LatestActivity from './components/LatestActivity/LatestActivity';
import LatestStudentActivity from './components/LatestStudentActivity/LatestStudentActivity';
// import LiveClasses from './components/LiveClasses/LiveClasses';
import MyTasks from './components/MyTasks/MyTasks';

import './Dashboard.scoped.scss';
import './Dashboard.global.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  tooltipElement?: React.ReactNode;
}

const Dashboard: React.FC<Props> = ({ style }) => {
  const user = useAppSelector(getUser);
  const PersonalTasks = RenderWithRole({
    student: <MyTasks />,
    parent: <MyTasks />,
  });
  const MyLiveClasses = RenderWithRole({
    student: <LatestActivity />,
    // teacher: <LiveClasses />
  });
  const LatestFromStudentActivities = RenderWithRole({ teacher: <LatestStudentActivity /> });
  const Chats = RenderWithRole({
    teacher: <LatestChat />,
    student: <LatestChat />,
    parent: <LatestChat />,
  });

  const { t } = useTranslation();

  const quotes = t('common:welcome.quotes', { returnObjects: true });

  function getRandomQuote() {
    const index = Math.floor(Math.random() * 6);
    return quotes[index];
  }

  return (
    <PersistantOptionsProvider>
      <div className="dashboard-container inner-page" style={style}>
        <div className="banner-section">
          {(user.role === 'student' || user.role === 'teacher') && (
            <Banner
              title={t('common:welcome.title', { user: user && user.first_name })}
              content={getRandomQuote()}
            />
          )}
          <div className="divider" />
        </div>

        <div className="content-section">
          <div className="content-section-right">
            <div className="content-section-right-top">
              {user.role === 'teacher' && (
                <UpcomingProvider>
                  <Upcoming />
                </UpcomingProvider>
              )}
              <div className="divider" />
              {PersonalTasks}
              {user.role !== 'teacher' && <div className="divider" />}
              <LatestActivityProvider>{MyLiveClasses}</LatestActivityProvider>
            </div>
          </div>
          <div className="dividerHorizontal" />
          <div className="content-section-left">
            <div className="content-section-left-top">
              <Classes />
              <div className="divider" />
              {Chats}
              {user.role === 'teacher' && <div className="divider" />}
              {LatestFromStudentActivities}
              <div className="divider" />
              {/* <Grades /> */}
            </div>
          </div>
        </div>
      </div>
    </PersistantOptionsProvider>
  );
};

export default Dashboard;
